import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import translate from "src/i18n/translate";
import { formatNumber, getPercentage } from "../../../src/static/js/commons";
import WidgetLoader from "../common/elements/WidgetLoader";
import ApiError from "../common/elements/ApiError";
export default function CourseCompletionRisk(_a) {
    var highRiskCourseEngagement = _a.highRiskCourseEngagement, lowRiskCourseEngagement = _a.lowRiskCourseEngagement, mediumRiskCourseEngagement = _a.mediumRiskCourseEngagement, notIndicatedRiskCourseEngagement = _a.notIndicatedRiskCourseEngagement, highRiskCourseCompletion = _a.highRiskCourseCompletion, lowRiskCourseCompletion = _a.lowRiskCourseCompletion, mediumRiskCourseCompletion = _a.mediumRiskCourseCompletion, notIndicatedRiskCourseCompletion = _a.notIndicatedRiskCourseCompletion, loader = _a.loader, termSummaryFailed = _a.termSummaryFailed;
    var _b = useState(false), lowRiskPopoverState = _b[0], setLowRiskPopoverState = _b[1];
    var _c = useState(false), mediumRiskPopoverState = _c[0], setMediumRiskPopoverState = _c[1];
    var _d = useState(false), highRiskPopoverState = _d[0], setHighRiskPopoverState = _d[1];
    var _e = useState(false), notIndicatedPopoverState = _e[0], setNotIndicatedPopoverState = _e[1];
    useEffect(function () {
        var lowRiskBtn = document.getElementById("low-risk");
        lowRiskBtn === null || lowRiskBtn === void 0 ? void 0 : lowRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === lowRiskBtn) {
                setLowRiskPopoverState(!lowRiskPopoverState);
            }
        });
    }, [lowRiskPopoverState]);
    useEffect(function () {
        var mediumRiskBtn = document.getElementById("medium-risk");
        mediumRiskBtn === null || mediumRiskBtn === void 0 ? void 0 : mediumRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === mediumRiskBtn) {
                setMediumRiskPopoverState(!mediumRiskPopoverState);
            }
        });
    }, [mediumRiskPopoverState]);
    useEffect(function () {
        var highRiskBtn = document.getElementById("high-risk");
        highRiskBtn === null || highRiskBtn === void 0 ? void 0 : highRiskBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === highRiskBtn) {
                setHighRiskPopoverState(!highRiskPopoverState);
            }
        });
    }, [highRiskPopoverState]);
    useEffect(function () {
        var notIndicatedBtn = document.getElementById("not-indicated");
        notIndicatedBtn === null || notIndicatedBtn === void 0 ? void 0 : notIndicatedBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && document.activeElement === notIndicatedBtn) {
                setNotIndicatedPopoverState(!notIndicatedPopoverState);
            }
        });
    }, [notIndicatedPopoverState]);
    function useClosePopoverOutsideClick(ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLowRiskPopoverState(false);
                    setHighRiskPopoverState(false);
                    setMediumRiskPopoverState(false);
                    setNotIndicatedPopoverState(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    var arrOfRiskBarVal = [
        Number(lowRiskCourseEngagement),
        Number(mediumRiskCourseEngagement),
        Number(highRiskCourseEngagement),
        Number(notIndicatedRiskCourseEngagement)
    ];
    var largestRiskValue = Math.max.apply(Math, arrOfRiskBarVal);
    var lowRiskCourseEnga = getPercentage(lowRiskCourseEngagement, largestRiskValue);
    var mediumRiskCourseEnga = getPercentage(mediumRiskCourseEngagement, largestRiskValue);
    var highRiskCourseEnga = getPercentage(highRiskCourseEngagement, largestRiskValue);
    var notIndicatedRiskCourseEnga = getPercentage(notIndicatedRiskCourseEngagement, largestRiskValue);
    var riskSummaryLabel = useIntl().formatMessage({
        id: "app.sse.riskSummaryLabel"
    });
    var lowRiskLabel = useIntl().formatMessage({
        id: "app.sse.lowRiskLabel"
    });
    var mediumRiskLabel = useIntl().formatMessage({
        id: "app.sse.mediumRiskLabel"
    });
    var highRiskLabel = useIntl().formatMessage({
        id: "app.sse.highRiskLabel"
    });
    var notIndicatedLabel = useIntl().formatMessage({
        id: "app.sse.notIndicatedLabel"
    });
    var riskSummaryLowRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryLowRiskText"
    });
    var riskSummaryMediumRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryMediumRiskText"
    });
    var riskSummaryHighRiskText = useIntl().formatMessage({
        id: "app.sse.riskSummaryHighRiskText"
    });
    var riskSummaryNotIndicatedText = useIntl().formatMessage({
        id: "app.sse.riskSummaryNotIndicatedText"
    });
    var lowRiskPopover = useIntl().formatMessage({
        id: "app.sse.lowRiskPopover"
    });
    var mediumRiskPopover = useIntl().formatMessage({
        id: "app.sse.mediumRiskPopover"
    });
    var highRiskPopover = useIntl().formatMessage({
        id: "app.sse.highRiskPopover"
    });
    var notIndicatedRiskPopover = useIntl().formatMessage({
        id: "app.sse.notIndicatedPopover"
    });
    var keyEngagementRiskLevel = useIntl().formatMessage({
        id: "app.sse.keyEngagementRiskLevel"
    });
    var wrapperRef = useRef(null);
    useClosePopoverOutsideClick(wrapperRef);
    var CourseCompletionRiskBody = function () {
        return (_jsx(_Fragment, { children: _jsx("div", { className: "body", children: _jsx("div", { className: "wm-grid", children: _jsxs("div", { className: "course-completion-conatiner wm-grid-row", children: [_jsxs("div", { id: "risk-summary", className: "risk-summary wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8", children: [_jsx("div", { className: "risk-summary-label", children: translate("app.sse.riskSummaryLabel") }), _jsxs(WmChart, { id: "risk-summary-chart", chartType: "doughnut2", label: riskSummaryLabel, valueFormat: "amount", "print-mode": true, children: [_jsx(WmChartSlice, { amount: String(lowRiskCourseCompletion), legend: lowRiskLabel, popoverTitle: formatNumber(lowRiskCourseCompletion), popoverText: riskSummaryLowRiskText }), _jsx(WmChartSlice, { amount: String(mediumRiskCourseCompletion), legend: mediumRiskLabel, popoverTitle: formatNumber(mediumRiskCourseCompletion), popoverText: riskSummaryMediumRiskText }), _jsx(WmChartSlice, { amount: String(highRiskCourseCompletion), legend: highRiskLabel, popoverTitle: formatNumber(highRiskCourseCompletion), popoverText: riskSummaryHighRiskText }), _jsx(WmChartSlice, { amount: String(notIndicatedRiskCourseCompletion), legend: notIndicatedLabel, popoverTitle: formatNumber(notIndicatedRiskCourseCompletion), popoverText: riskSummaryNotIndicatedText })] }, "risk-summary-chart")] }), _jsx("div", { id: "key-engagement", className: "key-engagement wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8", children: _jsx("div", { id: "key-engagement-chart", className: "key-engagement-chart", children: _jsxs(WmChart, { chartType: "bar7", label: keyEngagementRiskLevel, showLegend: false, showBarLegend: true, labelWidth: "95px", valueFormat: "percentage", children: [_jsx(WmChartSlice, { amount: formatNumber(lowRiskCourseEnga), legend: lowRiskLabel, popoverTitle: formatNumber(lowRiskCourseEngagement), popoverText: lowRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(mediumRiskCourseEnga), legend: mediumRiskLabel, popoverTitle: formatNumber(mediumRiskCourseEngagement), popoverText: mediumRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(highRiskCourseEnga), legend: highRiskLabel, popoverTitle: formatNumber(highRiskCourseEngagement), popoverText: highRiskPopover }), _jsx(WmChartSlice, { amount: formatNumber(notIndicatedRiskCourseEnga), legend: notIndicatedLabel, popoverTitle: formatNumber(notIndicatedRiskCourseEngagement), popoverText: notIndicatedRiskPopover })] }, "course-engagment-chart") }) })] }) }) }) }));
    };
    return (_jsx("div", { className: "wm-grid-col-12", children: _jsxs("div", { className: "paper-card paper-card-height", children: [_jsx("div", { className: "header", children: _jsxs("div", { className: "info", children: [_jsx("h3", { className: "title", children: translate("app.sse.courseCompletionRiskAndEngagement") }), _jsx("p", { className: "description -descs", children: translate("app.sse.courseCompletionDescription") })] }) }), loader && (_jsx(WidgetLoader, { loaderContainerClasses: "loader", loaderClasses: "content" })), !loader && !termSummaryFailed && _jsx(CourseCompletionRiskBody, {}), termSummaryFailed && _jsx(ApiError, {})] }) }));
}
